import { FC } from "react";
import styled from "@emotion/styled";

// const inputReg = new RegExp("[a-z]");

interface ALetterToGuessProps {
  guess: (newGuess: string) => void;
  letter: string | undefined;
  disabled?: boolean;
  onClick: () => void;
}

const ALetterToGuess: FC<ALetterToGuessProps> = ({ letter, onClick }) => {
  return <LetterGuessed onClick={onClick}>{letter}</LetterGuessed>;
};

const LetterGuessed = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 30px;
  height: 40px;
  margin-right: 1px;
  margin-left: 1px;
  vertical-align: center;
  background-color: white;
`;

export default ALetterToGuess;
